import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ecd3fc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "support" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "emq-table-footer" }

import { ref, computed, onMounted } from 'vue'
import { GetRescueOrderList } from '@/api/operation'
// 修改这里的colProps配置
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import {Search, RefreshLeft, Refresh} from '@element-plus/icons-vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { throttleBtn } from '@/common/tools'
import SelectOperator from '@/components/SelectOperator.vue'
import RoadRescueEdit from './components/RoadRescueEdit.vue'
import RoadRescueDetail from './components/RoadRescueDetail.vue'
import {pick} from "lodash";
import usePaginationRemember from "@/hooks/usePaginationRemember";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const colProps = {
  xs: 20,
  sm: 10,
  md: 8,
  lg: 6,
  xl: 4
}
const { t } = useI18nTl('Operation')
const { rescueOrderState, paymentModes, rescueType } = useProtocolEnums()

// 过滤掉Unknown状态(值为0)
const filteredRescueOrderState = computed(() => {
  return rescueOrderState.filter(item => item.value !== 0)
})

// 状态映射函数（需根据实际枚举定义补充）
const getRescueOrderStateLabel = (state) => {
  return rescueOrderState.find(item => item.value === state)?.label || "-"
}
const getPaymentModeLabel = (mode) => {
  return paymentModes.find(item => item.value === mode)?.label || "-"
}
const getRescueTypeLabel = (type) => {
  return rescueType.find(item => item.value === type)?.label || "-"
}

// 状态管理
const showDetailDialog = ref(false)
const showDetailData = ref({})
const showEditDialog = ref(false)
const showEditData = ref({})
const tableData = ref([])
const lockTable = ref(false)
const fuzzyParams = ref({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('rescue')

const viewDetail = (row: any) => {
  showDetailData.value = row // 使用展开运算符创建新对象
  showDetailDialog.value = true
}

const editOrder = (row: any) => {
  showEditData.value = row // 使用展开运算符创建新对象
  showEditDialog.value = true
}

// 搜索逻辑
const handleSearch = async () => {
  const params = {
    ...fuzzyParams.value,
    pageReq: pageParams.value
  }
  await loadTables(params)
}
const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

// 加载表格数据
const loadTables = async (params = {}) => {
  lockTable.value = true
  try {
    // 修正参数处理方式
    const queryParams = {
      ...(typeof params === 'object' ? params : {}),
      ...fuzzyParams.value,
      pageReq: {
        ...pageParams.value,
        ...(params.pageReq || {})
      }
    }

    const { list, pageReply } = await GetRescueOrderList(queryParams)
    const meta = toPageMeta(queryParams.pageReq, pageReply)

    tableData.value = list || []
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...fuzzyParams.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

// 修改loadDatasRefreshLimit调用方式
const loadDatasRefreshLimit = throttleBtn(() => {
  return loadTables({
    ...fuzzyParams.value,
    pageReq: pageParams.value
  })
})
onMounted(() => {
  loadTables({...fuzzyParams.value,
    pageReq: pageParams.value})
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(SelectOperator, {
                  modelValue: fuzzyParams.value.operatorId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.userName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.userName) = $event)),
                  placeholder: _ctx.$t('Base.username')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.phone) = $event)),
                  placeholder: _ctx.$t('Base.phone')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.plateNumber,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.plateNumber) = $event)),
                  placeholder: _ctx.$t('Operation.platenumber')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: fuzzyParams.value.state,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fuzzyParams.value.state) = $event)),
                  placeholder: _ctx.$t('Base.state')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredRescueOrderState), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _mergeProps(colProps, { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Refresh),
                  onClick: _unref(loadDatasRefreshLimit)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
                  ]),
                  _: 1
                }, 8, ["icon", "onClick"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref: "TableCom",
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            "min-width": "100",
            label: _ctx.$t('Operation.orderId')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "rescueType",
            "min-width": "120",
            label: _ctx.$t('Operation.rescueType')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(getRescueTypeLabel(row.rescueType)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "userName",
            "min-width": "80",
            label: _ctx.$t('Base.username')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "phone",
            "min-width": "100",
            label: _ctx.$t('Base.phone')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "plateNumber",
            "min-width": "100",
            label: _ctx.$t('Operation.platenumber')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "address",
            "min-width": "150",
            label: _ctx.$t('Base.address'),
            "show-overflow-tooltip": true
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            "min-width": "100",
            label: _ctx.$t('Base.state')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(getRescueOrderStateLabel(row.state)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "needPay",
            "min-width": "80",
            label: _ctx.$t('Operation.needPay')
          }, {
            default: _withCtx(({ row }) => [
              (row.needPay)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('Base.yes')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('Base.no')), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "payMode",
            "min-width": "120",
            label: _ctx.$t('Operation.payMode')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(getPaymentModeLabel(row.payMode)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "payAmount",
            "min-width": "100",
            label: _ctx.$t('Operation.payAmount')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString((row.payAmount / 100).toFixed(2)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "120",
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation",
            fixed: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (viewDetail(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.detail')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editOrder(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'supportRescueOrderOperate']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[5] || (_cache[5] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTables
        }, null, 8, ["metaData"])
      ]),
      _createVNode(RoadRescueEdit, {
        modelValue: showEditDialog.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showEditDialog).value = $event)),
        data: showEditData.value,
        onSuccess: _unref(loadDatasRefreshLimit)
      }, null, 8, ["modelValue", "data", "onSuccess"]),
      _createVNode(RoadRescueDetail, {
        modelValue: showDetailDialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showDetailDialog).value = $event)),
        data: showDetailData.value,
        onSuccess: _unref(loadDatasRefreshLimit)
      }, null, 8, ["modelValue", "data", "onSuccess"])
    ])
  ]))
}
}

})